import { useEffect, useState } from "react";
import { AdminDogsDetailSearch } from "../dogs/adminDogDetailsSearch";
import Swal from "sweetalert2";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { AdminMainWrapper } from "../mini-components/admin-main-wrapper";
import { useNavigate, useParams } from "react-router-dom";
import profile from "../images/profile.jpg";
import { url } from "../../weburl";
import axios from "axios";
import { Button } from "@mui/material";

export const AdminUserDetails = () => {
  const [user, setUser] = useState({});
  const navigate = useNavigate();
  const params = useParams();

  const fetchUser = () => {
    axios
      .get(`${url}api/users/getone/${params.id}`)
      .then((res) => {
        setUser(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log("Error couldnt get Dog");
        console.log(err.message);
      });
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const deleteUser = () => {
    //currently no route for deleting user
    Swal.fire("Deleted!", "", "success");
  };

  return (
    <AdminMainWrapper>
      <div className="row align-items-start justify-content-center py-4 bg-white">
        <div className="col-sm-4 text-left">
          <div>
            <AiOutlineArrowLeft onClick={() => navigate(-1)} />
          </div>
          <div className="">
            <img
              src={

                (user.public_id &&
                  `https://res.cloudinary.com/daurieb51/image/upload/v1642082142/${user.public_id}`) ||
                profile
              }
              className="w-100"
            />
            <hr />
            <div >
              <p className="brand-yellow-font">User Roles and Permissions</p>
              <p>User role: {"Customer"}</p>
              <p>Admin: {"No"}</p>
            </div>
            <div>
              <Button sx={{color: "#ba8108"}}>Edit</Button>
              <Button sx={{color: "red"}}
                onClick={(e) =>
                  Swal.fire({
                    title: `ARE YOU SURE YOU WANT TO DELETE ${user.username}?`,
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: "Delete",
                    denyButtonText: `Don't delete`,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      deleteUser();
                    } else if (result.isDenied) {
                      Swal.fire("Changes are not saved", "", "info");
                    }
                  })
                }
              >
                Delete
              </Button>
            </div>
          </div>
        </div >

        <div className="col-sm-5 text-left">
          <div>
            {/*user info*/}
            <h1 className="font-weight-bold brand-yellow-font"> {user.username}</h1>
            <hr />
           <div className="pt-2">
              <h5 className="brand-yellow-font">User Information</h5>
  
  
              <p>Email: {user.email}</p>
              <p>Phone Number: {user.phone_number}</p>
              <p>Address: {user.contact_address}</p>
              <p>User ID: {user.uid}</p>
              <p>Date Registered: </p>
           </div>
          </div>
          <hr />
          <div className="pt-2">
            <h5 className="brand-yellow-font">Dog Registration Information</h5>
            <p>No of dogs registered: {"N/A"}</p>
            {/* <p>Registered Dogs: {}</p> */}
            {/* <p>Registration numbers: {" 25835635"}</p> */}
          </div>
          <hr />
          <div className="pt-2">
            <h5 className="brand-yellow-font">Online Information</h5>
           <p>Posts : N/A</p>
           <p>Advertissements: N/A</p>
           <p></p>
          </div>
          <hr />
          <div className="pt-2">
            <h5 className="brand-yellow-font">Payments and Billing Information</h5>
            <p>Payment History: {user.username}</p>
            {/* <h5>Billing Information</h5>
            <p>Name: {user.username}</p>
            <p>Card Number: {"lorem ipson"}</p> */}
          </div>
          <hr />
          {/*Activity and History*/}
          {/* Payment and Billing */}
        </div>
      </div>
    </AdminMainWrapper>
  );
};
